import { BookedTravelerCollectionInt, Meta } from "@app/interfaces";
import { Reservation } from "../reservation.model";
import { BookedTravelerCollection } from "./booked-traveler-collection.model";

export class CartPNRUpdate {
  public _meta: Meta;
  public cartId: string;
  public travelerInfo: any;

  constructor(value: { reservation:Reservation, apiCart?:BookedTravelerCollectionInt }) {
    const { reservation, apiCart } = value;
    this._meta= { class: 'CartPNRUpdate'};

    this.cartId = reservation.flightSummary.cartId;
    if (!apiCart) {
      this.travelerInfo = new BookedTravelerCollection();
    } else if (apiCart) {
      this.travelerInfo = new BookedTravelerCollection(apiCart.travelerInfo);
    } else {
      this.travelerInfo = new BookedTravelerCollection().buildWithReservation(reservation);
    }
  }

  addBookedTraveler(BookedTraveler) {
    this.travelerInfo.addBookedTraveler(BookedTraveler);
  }

  clearPremiereUpgrade() {
    this.travelerInfo.clearPremiereUpgrade();
  }

  clearSeats() {
    this.travelerInfo.clearSeats();
  }

  findBookedTravelerById(id) {
    return this.travelerInfo.findBookedTravelerById(id);
  }

  /**
   * Validates that this obj is ready to be sent ot the server
   * @return {boolean|*} true when valid, false otherwise
   */
  validate() {
    return this.cartId != null && this.travelerInfo.validate();
  }

  getSeatBalance() {
    return this.travelerInfo.getSeatBalance();
  }

  /**
   * objects with empty _collection will be set to null
   */
  clearEmpty() {
    this.travelerInfo.clearEmpty();
  }

}
